import { Routes } from '@angular/router';

// Components
import { AboutComponent } from './about/about.component';
import { HomeComponent } from './home/home.component';
import { SuccessComponent } from './success/success.component';
import { ErrorComponent } from './error/error.component';
import { DataprotectionComponent } from './dataprotection/dataprotection.component';
// import { WinterkampagneComponent } from './winterkampagne/winterkampagne.component';
// Kampagnenseite deaktiviert (2026-09) - Komponente bleibt fuer eine spaetere Reaktivierung erhalten
// import { FensterglanzComponent } from './fensterglanz/fensterglanz.component';
import { HubspotFormComponent } from './components/hubspot-form/hubspot-form.component';
import { DankeComponent } from './components/danke/danke.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '',
  },
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'about',
    component: AboutComponent,
  },
  {
    path: 'FAQ',
    loadChildren: () =>
      import('./faq/faq-component.routes').then((m) => m.routes),
  },
  {
    // Stadt-Landingpage entfernt (2026-09) - Altlinks auf die Startseite leiten
    path: 'zuerich',
    pathMatch: 'full',
    redirectTo: '',
  },
  {
    path: 'kontakt',
    component: HubspotFormComponent,
    children: [
      {
        path: 'danke',
        component: DankeComponent,
      },
    ]
  },
  {
    // Stadt-Landingpage entfernt (2026-09) - Altlinks auf die Startseite leiten
    path: 'winterthur',
    pathMatch: 'full',
    redirectTo: '',
  },
  {
    // Kampagnenseite deaktiviert (2026-09) - Altlinks auf die Startseite leiten.
    // Zum Reaktivieren: Import oben und den auskommentierten Block unten wieder einblenden.
    path: 'fensterglanz',
    pathMatch: 'full',
    redirectTo: '',
  },
  // {
  //   path: 'fensterglanz',
  //   component: FensterglanzComponent,
  // },
  // {
  //   path: 'winterkampagne',
  //   component: WinterkampagneComponent,
  // },
  {
    path: 'success',
    component: SuccessComponent,
  },
  {
    path: 'failed',
    component: ErrorComponent,
  },
  {
    path: 'imprint',
    component: DataprotectionComponent,
  },
  {
    path: '**',
    redirectTo: 'failed',
  },
];
